'use client';
/**
 * Инвариант.
 *
 * @param condition - Условие, при выполнении которого выбрасывается ошибка.
 * @param factory - Фабрика, производящая экземпляр ошибки.
 *
 * @primaryExample
 * invariantSync(requestFailed, () => new HTTPError());
 *
 * @stable
 * */ var invariantSync = function(condition, factory) {
    if (condition) {
        throw factory();
    }
};

export { invariantSync };
